/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useMemo} from "react";
import { getMonth, getYear, differenceInDays, addDays, getDate } from "date-fns";
import { parseDateLocal } from "@/utils/timeUtils";

import { 
    type CrewInterface,
    type PositionInterface,
    type DepartmentInterface,
} from "./types";

import { CalendarRow } from "./CalendarRow";

type Props = {
    isLoading: boolean;
    startDate: string | null | undefined;
    endDate: string | null | undefined;
    calendarData: any;
    calendarGeneralAdditionalData: any;
    calendarZoomLevel: number;
    moveChangeDay: {
        from: null | string;
        to: null | string;
    };
    onClickDayHandler: ({ day, crewMemberData }: {
        day: {
            date: string;
            type: string;
        };
        crewMemberData: {
            id: number;
            first_name: string;
            last_name: string;
            rotation: string;
            position_id: number;
            partner_id: number;
        };
    }) => void;
    crewMemberData: {
        id: number;
        first_name: string;
        last_name: string;
        rotation: string;
        position_id: number;
        partner_id: number;
    } | null | undefined;
    onClickDocumentHandler: ({ documentBatchData, userId }: {
        documentBatchData: any;
        userId: string;
    }) => void
}

const CalendarDays = ({
    isLoading,
    startDate,
    endDate,
    calendarData,
    calendarGeneralAdditionalData,
    calendarZoomLevel,
    moveChangeDay,
    onClickDayHandler,
    crewMemberData,
    onClickDocumentHandler
}: Props) => {
    const calendarDaysData = useMemo(() => {
        if(!calendarData?.data || !startDate || !endDate) return null;

        const dayDifference = differenceInDays(parseDateLocal(endDate), parseDateLocal(startDate)) + 1;

        const preparedData = calendarData.data.departments.map((department: DepartmentInterface[]) => {
            const positions = department.positions.map((position: PositionInterface) => {
                const crew = position.crew.map((crewMember: CrewInterface) => {

                    const calendarWithEmptyDays = {};
                    for(let i = 0; i < dayDifference; i++) {
                        const currentDate = addDays(parseDateLocal(startDate), i);
                        const month = getMonth(currentDate) + 1;
                        const year = getYear(currentDate);
                        const day = getDate(currentDate);
                        const monthKey = `${year}-${month}-${day}`;
                        calendarWithEmptyDays[monthKey] = 'undefined';
                    }

                    const currentCalendar = crewMember.calendar.reduce((acc, calendar) => {
                        const _calendar = {};
                        for(let i = 0; i < calendar.duration; i++) {
                            const currentDate = addDays(parseDateLocal(calendar.start_date), i);
                            const month = getMonth(currentDate) + 1;
                            const year = getYear(currentDate);
                            const day = getDate(currentDate);
                            const monthKey = `${year}-${month}-${day}`;
                            _calendar[monthKey] = calendar.type;
                        }

                        return {...acc, ..._calendar};
                    }, {});

                    const mergedCalendar = {...calendarWithEmptyDays, ...currentCalendar};

                    const sortedCalendar = Object.entries(mergedCalendar).reduce((acc, [key, value]) => {
                        const [year, month] = key.split("-");
                        const monthKey = `${year}-${month}`;
                        if(!acc[monthKey]) {
                            acc[monthKey] = [];
                        }
                        acc[monthKey].push({
                            type: value,
                            duration: 1,
                            start_date: key
                        });
                        return acc;
                    }, {});

                    const preparedCalendar = Object.entries(sortedCalendar).reduce((acc, [monthKey, days]) => {
                        acc[monthKey] = days.reduce((acc, day) => {
                            const lastDay = acc[acc.length - 1];
                            if(lastDay && lastDay.type === day.type) {
                                lastDay.duration += 1;
                            } else {
                                acc.push({...day});
                            }
                            return acc;
                        }, []);

                        return acc;
                    }, {});

                    return {...crewMember, calendar: preparedCalendar};
                });

                return {...position, crew}
            });

            return {...department, positions};
        })


        return preparedData;
    }, [calendarData, startDate, endDate]);

    return (
        <>
            { (!isLoading) && 
                (calendarDaysData?.map( department => (
                    <div className="grow" key={department.id}>

                        <div className="h-3.5"></div>
                        {/* <hr className="pb-1"/> */}
                        <div className="h-1"></div>

                        { department.positions.map( position => (
                            <div className="grow" key={position.id}>

                                    { position.crew.map( crewMember => 
                                        <CalendarRow 
                                            crewMember={crewMember}
                                            calendarZoomLevel={calendarZoomLevel}
                                            startDate={startDate}
                                            endDate={endDate}
                                            calendarGeneralAdditionalData={calendarGeneralAdditionalData}
                                            onClickDayHandler={onClickDayHandler}
                                            moveChangeDay={moveChangeDay}
                                            crewMemberData={crewMemberData}
                                            onClickDocumentHandler={onClickDocumentHandler}
                                        />
                                    )}

                                    { !position.crew?.length && (
                                        <div className="text-sm italic font-light mb-2">No data for &apos;{position.name}&apos;</div>
                                    )}
                            </div>
                        ))}
                    </div>
                )))
            }
        </>
    );
};

export { CalendarDays };
